import { Grid } from "@material-ui/core";

import AutoCompleteField from "components/_refactor/fields/autocomplete";
import InputText from "components/_refactor/text/input";

import MaskAndValid from "utils/maskAndValid";

import regionOptions from "../data/brazil-regions.json";

const statusOptions = [
  { label: "Todos", value: "TODOS" },
  { label: "Ativo", value: "ATIVO" },
  { label: "Inativo", value: "INATIVO" },
];

export default function Filters({
  isLoading,
  filters,
  setFilters,
  grupoEconomicoOptions = [],
  razaoSocialOptions = [],
}) {
  const handleChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleCnpjChange = (e) => {
    const value = MaskAndValid.maskCNPJ(e.target.value);
    handleChange("cnpj", value);
  };

  return (
    <>
      <Grid container spacing={2} style={{ padding: "1rem 0" }}>
        <Grid item xs={12} md={4} lg={3} xl={2}>
          <AutoCompleteField
            options={statusOptions}
            label="Status"
            optionLabelKey="label"
            optionIdKey="value"
            onChange={(option) => handleChange("status", option)}
            disabled={isLoading}
            value={filters.status}
            required={false}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3} xl={2}>
          <AutoCompleteField
            options={regionOptions}
            label="Região"
            optionLabelKey="label"
            optionIdKey="value"
            onChange={(option) => handleChange("region", option)}
            disabled={isLoading}
            value={filters.region}
            required={false}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3} xl={2}>
          <AutoCompleteField
            options={grupoEconomicoOptions}
            label="Grupo econômico"
            optionLabelKey="Nome"
            optionIdKey="Id"
            onChange={(option) => handleChange("grupoEconomico", option)}
            disabled={isLoading}
            value={filters.grupoEconomico}
            required={false}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3} xl={2}>
          <AutoCompleteField
            options={razaoSocialOptions}
            label="Razão social"
            optionLabelKey="Nome"
            optionIdKey="Id"
            onChange={(option) => handleChange("razaoSocial", option)}
            disabled={isLoading}
            value={filters.razaoSocial}
            required={false}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3} xl={2}>
          <InputText
            placeholder="CNPJ"
            onChange={handleCnpjChange}
            disabled={isLoading}
            required={false}
            value={filters.cnpj || ""}
            className="form-control"
            style={{ width: "100%" }}
            label="CNPJ"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <InputText
            placeholder="Pesquisar representantes"
            onChange={(e) => handleChange("search", e.target.value)}
            disabled={isLoading}
            required={false}
            value={filters.search}
            className="form-control"
            style={{ width: "100%" }}
            label="Pesquisar representantes"
          />
        </Grid>
      </Grid>
    </>
  );
}
